// Los diccionarios los aportan las apps desde su main.jsx: aqui solo viven las
// funciones. Son dos y NO se fusionan, asi que la misma clave puede estar en los
// dos sin que ninguno pise al otro: getText da el de la app, getTextCore el del core.
const appResources = {};
const coreResources = {};

export const registerTranslations = (...dictionaries) => {
    Object.assign(appResources, ...dictionaries);
}

// Textos compartidos entre apps. Solo lo registra quien los necesita.
export const registerCoreTranslations = (...dictionaries) => {
    Object.assign(coreResources, ...dictionaries);
}

// Idioma del documento; sin traduccion cae a ingles y luego a la propia clave.
const resolve = (entry, resource, dictionary) => {
    if (entry === undefined) {
        if (import.meta.env?.DEV) {
            console.warn(`[language] clave sin registrar en ${dictionary}: ${resource}`);
        }
        return resource;
    }
    const lang = document.documentElement.getAttribute('lang');
    return entry[lang] ?? entry['en'] ?? resource;
}

// La app tiene prioridad sobre el core, que actua de respaldo. Es lo que permite que
// las claves montadas en runtime (getText('error_' + payload)) salgan de cualquiera
// de los dos sin que el sitio de la llamada tenga que saber donde vive el texto.
export const getText = (resource) => {
    if (resource == undefined) {
        return '';
    }
    return resolve(appResources[resource] ?? coreResources[resource], resource, 'ningun diccionario');
}

export const getErrorText = (resource, fallbackResource) => {
    const key = 'error_' + resource;
    const text = getText(key);
    if (text !== key) {
        return text;
    }
    return (fallbackResource === undefined) ? getText('error_unknown') : getText(fallbackResource);
}

// Fuerza el texto del core aunque la app tenga uno propio con la misma clave.
export const getTextCore = (resource) => {
    if (resource == undefined) {
        return '';
    }
    return resolve(coreResources[resource], resource, 'el diccionario del core');
}

// Nombre localizado de un tipo de actividad (claves nombreTipo<TYPE>). Si el
// tipo no tiene traduccion, cae al codigo en crudo (p.ej. un tipo nuevo).
export const getTypeName = (type) => {
    const key = 'nombreTipo' + type;
    const text = getText(key);
    return text === key ? (type ?? '') : text;
}

const alphabets = [];

const buildAlphabet = (alphabet) => {
    if (alphabets[alphabet] === undefined) {
        const dictionary = {
            latin: [{ start: 65, end: 65, weigth: 3 },
            { start: 66, end: 68 },
            { start: 69, end: 69, weigth: 3 },
            { start: 70, end: 72 },
            { start: 73, end: 73, weigth: 3 },
            { start: 74, end: 78 },
            { start: 79, end: 79, weigth: 3 },
            { start: 80, end: 84 },
            { start: 85, end: 85, weigth: 3 },
            { start: 86, end: 90 }],
            numbers: [{ start: 48, end: 57 }],
            han: [{ start: 19968, end: 40959 }],
            katakana: [{ start: 12449, end: 12538 }],
            hiragana: [{ start: 12353, end: 12436 }],
            bopomofo: [{ start: 12549, end: 12585 }],
            hangul: [{ start: 4352, end: 4370 },
            { start: 4449, end: 4469 },
            { start: 4520, end: 4546 }],
            devanagari: [{ start: 2308, end: 2361 }],
            bengali: [{ start: 2437, end: 2444 },
            { start: 2447, end: 2448 },
            { start: 2451, end: 2472 },
            { start: 2474, end: 2480 },
            { start: 2482, end: 2482 },
            { start: 2486, end: 2489 }],
            thai: [{ start: 3585, end: 3630 }],
            ethiopic: [{ start: 4608, end: 4680 },
            { start: 4682, end: 4685 },
            { start: 4688, end: 4694 },
            { start: 4696, end: 4696 },
            { start: 4698, end: 4701 },
            { start: 4704, end: 4744 },
            { start: 4746, end: 4749 },
            { start: 4752, end: 4784 },
            { start: 4786, end: 4789 },
            { start: 4792, end: 4798 },
            { start: 4800, end: 4800 },
            { start: 4802, end: 4805 },
            { start: 4808, end: 4822 },
            { start: 4824, end: 4880 },
            { start: 4882, end: 4885 },
            { start: 4888, end: 4954 }],
            arabic: [{ start: 1569, end: 1569 },
            { start: 1575, end: 1594 },
            { start: 1601, end: 1610 }],
            hebrew: [{ start: 1488, end: 1514 }],
            greek: [{ start: 913, end: 929 },
            { start: 931, end: 937 }],
            cyrillic: [{ start: 1040, end: 1071 }]
        }
        const rangeBlock = [];
        if (dictionary[alphabet].length > 1) {
            let initialRangeBlock = 0;
            dictionary[alphabet].forEach((range, indexRange) => {
                let weigth;
                if (range.weigth === undefined) {
                    weigth = range.end - range.start;
                } else {
                    weigth = range.weigth - 1;
                }
                rangeBlock[indexRange] = initialRangeBlock + weigth;
                initialRangeBlock += weigth + 1;
            });
        } else {
            rangeBlock[0] = 0;
        }
        alphabets[alphabet] = {
            dictionary: dictionary[alphabet],
            range: rangeBlock
        };
    }
}

export const getRandomLetter = (alphabet) => {
    buildAlphabet(alphabet);
    let idBlock = 0;
    if (alphabets[alphabet].range.length > 1) {
        const randomIndex = Math.trunc(Math.random() * (alphabets[alphabet].range[alphabets[alphabet].range.length - 1] + 1));
        let i = 0;
        do {
            idBlock = i;
            i++;
        } while ((i < alphabets[alphabet].range.length) && (randomIndex > alphabets[alphabet].range[i - 1]));
    }
    const code = Math.trunc(Math.random() * (alphabets[alphabet].dictionary[idBlock].end - alphabets[alphabet].dictionary[idBlock].start + 1)) + alphabets[alphabet].dictionary[idBlock].start;
    return String.fromCharCode(code)
}